import { Box, Card, Typography } from '@mui/material';
import { PrimaryButton } from '../../components/primary-button';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import CustomIcon from '../../components/CustomIcon';

export function HeaderWidget({
    title,
    subtitle,
    image,
    startIcon,
    sx,
    actions,
    ...other
}) {
    // use theme
    const theme = useTheme();
    const themeGradient = theme.palette.gradients.primary;
    const cardBackground = image ? `url(${image}) no-repeat center center` : themeGradient;

    return (
        <Card
            sx={{
                width: '100%',
                height: actions && actions.length > 0 ? 200 : 130,
                borderRadius: '20',
                padding: 2.5,
                background: cardBackground,
                ...sx
            }}
            {...other}
        >
            <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                <Box>
                    <Box display="flex" alignItems="center">
                        {startIcon && <CustomIcon icon={startIcon} size={32} /> }
                        <Typography variant="title" sx={{ color: theme.palette.grey[100], ml: 1 }}>
                            {title}
                        </Typography>
                    </Box>
                    {subtitle && (
                        <Typography variant="subtitle1" sx={{ color: 'white' }}>
                            {subtitle}
                        </Typography>
                    )}
                </Box>

                {actions && actions.length > 0 && (
                    <Box display="flex" gap={1}>
                        {actions.map((action, index) => (
                            <PrimaryButton
                                key={index}
                                title={action.title}
                                subtitle={action.subtitle}
                                startIcon={action.icon}
                                onClick={action.onClick}
                            />
                        ))}
                    </Box>
                )}
            </Box>
        </Card>
    );
}
HeaderWidget.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    image: PropTypes.string,
    startIcon: PropTypes.elementType,
    sx: PropTypes.object,
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            subtitle: PropTypes.string,
            icon: PropTypes.node,
            onClick: PropTypes.func
        })
    )
};
